import { render } from "./Accounts.vue?vue&type=template&id=684f111c&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"

import "./Accounts.vue?vue&type=style&index=0&id=684f111c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-684f111c"

export default script